interface GetWhatsAppAuthContentKeyParams {
  sessionIntegrationId?: number;
  sessionGeneration?: number;
  fallbackIntegrationId: number;
}

/** Новая auth-generation должна размонтировать локальный pairing UI. */
export const getWhatsAppAuthContentKey = ({
  sessionIntegrationId,
  sessionGeneration,
  fallbackIntegrationId,
}: GetWhatsAppAuthContentKeyParams) =>
  `${sessionIntegrationId ?? fallbackIntegrationId}:${sessionGeneration ?? 0}`;
